const AUTH_EMAIL_KEY = 'IW_AUTH_EMAIL';

export function setAuthEmailForApi(email: string | null | undefined) {
  try {
    if (!email) {
      window.localStorage?.removeItem(AUTH_EMAIL_KEY);
      return;
    }
    window.localStorage?.setItem(AUTH_EMAIL_KEY, email);
  } catch {
    // ignore storage errors
  }
}

export function getAuthEmailForApi(): string | null {
  try {
    const v = window.localStorage?.getItem(AUTH_EMAIL_KEY);
    if (!v) return null;
    const trimmed = v.trim();
    return trimmed ? trimmed : null;
  } catch {
    return null;
  }
}

/**
 * Backend currently uses Authorization as an *unverified* stable key for rate limiting + usage attribution.
 * This is not strong security; for real security we must verify Firebase ID tokens server-side.
 */
export function buildAuthHeader(): Record<string, string> {
  const email = getAuthEmailForApi();
  if (!email) return {};
  return { Authorization: `Bearer ${email}` };
}
